import UserModel from './UserModel';
import MessageModel from './MessageModel';

export default class MessageThreadModel {
  constructor(data) {
    if (!data) {
      data = {};
    }

    this.id = data.id || 0;
    this.sender = data.sender ? new UserModel(data.sender) : null;
    this.receiver = data.receiver ? new UserModel(data.receiver) : null;

    this.latest_message = data.latest_message ? new MessageModel(data.latest_message) : null;
    this.has_unread = data.has_unread || false;


    // if we have a this.latest_message, lets just use the most recent sender/receiver
    if (this.latest_message) {
      this.sender = this.latest_message.sender;
      this.receiver = this.latest_message.receiver;
    }

  }

  otherUserName(myUserId) {
    if (this.systemMessage) {
      return 'BetterMynd Support Team';
    }

    if (myUserId === this.sender.id && this.receiver) {
      return this.receiver.displayName
    } else {
      return this.sender.displayName;
    }
  }

  get systemMessage() {
    return !this.sender;
  }

  get senderDisplay() {
    if (this.systemMessage) {
      return 'BetterMynd Support Team';
    }
    return this.sender.displayName;
  }

  get recipientDisplay() {
    if (this.systemMessage) {
      return 'BetterMynd Support Team';
    }

    if (this.receiver) {
      return this.receiver.displayName;
    }
    return '';
  }
}
